import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AuthRepository } from "./auth.repository";
import { LoginRequest, LoginResponse } from "../models/login.model";

@Injectable({providedIn: 'root'})
export class AuthApiRepository extends AuthRepository {
    constructor(private http: HttpClient){
        super();
    }

    // login(email: string, password: string): Observable<any> {
    //     const url = `https://devapi.studiflats.com/api/Admin/Login`;
       

      
    //     const params = new HttpParams()
    //       .set('UserMail', email)
    //       .set('Password', password);

       
      
    //     return this.http.post(url, null, { params }); 
    //   }

    override login(request: LoginRequest): Observable<LoginResponse> {
        return this.http.post<LoginResponse>(
      `${environment.apiUrl}/Mobile/Auth/Login`,
      request
    );
    }
}

